import React, { memo } from 'react';
import { Flex, Text } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { FiAlertOctagon } from 'react-icons/fi';
import colors from '../../../../../../styles/colors';
/**
 * Shown inside the Comparison section when the candidate does not meet
 * the requisition availability requirements.
 */
export const AvailabilityMismatchAlert = memo(() => {
  const { t } = useTranslation('requisition');

  return (
    <Flex
      align="center"
      gridGap="10px"
      px={4}
      py={3}
      bg={colors.requisitionDetails.alertBg}
      borderLeft="4px solid"
      borderColor="red.400"
      borderRadius="4px"
    >
      <FiAlertOctagon color={colors.requisitionDetails.alertIcon} size={20} />
      <Text fontSize="13px" color={colors.darkBg}>
        {t('candidateDoesNotMeetAvailability')}
      </Text>
    </Flex>
  );
});

AvailabilityMismatchAlert.displayName = 'AvailabilityMismatchAlert';
